// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"iz_a bhj_vr bhj_iv bhj_wf bhj_i bhj_j bhj_q bhj_un bhj_en bhj_ri bhj_rj bhj_cx","CommentsButton__icon":"iz_b bhj_re"};